import { toPlainText } from "@portabletext/react";
import { getImageUrlForWidth } from "src/components/images/imageFunctions";
import { FilmnyttArticleProps } from 'src/lib/pages/Filmnytt';
import { getUrlForDoctype } from "src/lib/types/sanity";
import Head from 'next/head';
import JSONLD from "src/components/seo/JSONLD";
import IFilmnytt from "src/lib/types/Filmnytt";

//#region [Component]
type NewsSeoProps = {
    document: IFilmnytt;
}

export default function NewsSeo({ document }: NewsSeoProps) {

    let canonical: string = `https://www.filmweb.no${getUrlForDoctype(document._type, document.slug.current, document.isStreaming)!}`; // self referencing canonicals is good

    const ingessAsPlainText: string | undefined = (document.ingress?.length ?? 0) === 0 ? undefined : toPlainText(document.ingress!);

    const image = (document.imageV2?.length ?? 0) > 0 ? document.imageV2![0] : null;
    let imgUrl: string | undefined;
    if ((image?.asset?._id ?? image?.asset?._ref)) {
        imgUrl = getImageUrlForWidth(image, 1200);
    }


    return <Head>
        <link key="canonical" rel="canonical" href={canonical} />
        <meta key="ogTitle" property="og:title" content={document.title} />
        {ingessAsPlainText && <>
            <meta key="ogDescription" property="og:description" content={ingessAsPlainText} />
            <meta key="metaDescription" name="description" content={ingessAsPlainText} />
        </>
        }
        <meta key="metaTitle" name="title" content={document.title} />
        {imgUrl && <meta key="ogImage" property="og:image" content={imgUrl} />}
        <meta key="ogUrl" property="og:url" content={canonical} />
        <meta key="ogType" property="og:type" content="article" />
        <title key="title">{`${document.title} - Filmweb`}</title>
        <JSONLD document={document} />
    </Head>
}
//#endregion